/**
 * The default priority for internal handlers.
 *
 * @since 3.0.0
 */
export const DEFAULT_EVENT_PRIORITY = 10;

/**
 * The default priority for users' handlers.
 *
 * @since 3.0.0
 */
export const DEFAULT_USER_EVENT_PRIORITY = 20;
